module.exports = __webpack_public_path__ + "assets/img/TX.a08160a5.png";